import { palette } from '../global/palette';
import type { ComponentOverride } from '../types';

export const MuiDialogContentText: ComponentOverride<'MuiDialogContentText'> = {
  MuiDialogContentText: {
    styleOverrides: {
      root: {
        color: palette.grey[800],
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    defaultProps: {
      variant: 'body2',
    },
  },
};
